import { render, staticRenderFns } from "./smMenuItem.vue?vue&type=template&id=31fe8eae&"
import script from "./smMenuItem.vue?vue&type=script&lang=js&"
export * from "./smMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./smMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports